<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h4 class="modal-title">Suspend Recurring Invoice</h4>
    <button
      type="button"
      class="close invoice_closemodal_button"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group" *ngIf="model">
      <label>Suspension End Date</label>
      <input
        type="date"
        class="form-control invoice_suspensiondate_input"
        [ngModel]="model.SuspensionEndDate | date: 'yyyy-MM-dd'"
        required
        [min]="minDate"
        (ngModelChange)="model.SuspensionEndDate = $event"
        name="SuspensionEndDate"
      />
    </div>
    <div class="form-group">
      <label>Reason:</label>
      <textarea
        [(ngModel)]="model.Reason"
        class="form-control invoice_suspensionreason_input"
      ></textarea>
    </div>
    <div class="footnote-dialog" *ngIf="model.CreatedDate">
      <ul>
        <li>
          <p class="invoice_createdby_text">
            <span>Created by</span>{{ model.CreatedByUserName }}
          </p>
          <p class="invoice_createdon_text">
            <span>Created on</span
            >{{ model.CreatedDateTZBased | date: "MM/dd/yyyy hh:mm:ss" }}
          </p>
        </li>
        <li *ngIf="model.UpdatedDate">
          <p class="invoice_updatedby_text">
            <span>Updated by</span>{{ model.UpdatedByUserName }}
          </p>
          <p class="invoice_updatedon_text">
            <span>Last updated on</span
            >{{ model.UpdatedDateTZBased | date: "MM/dd/yyyy hh:mm:ss" }}
          </p>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline invoice_savesuspension_button"
      (click)="save()"
      *ngIf="!viewOnly"
      [disabled]="busy || !isFormvalid()"
    >
      <i class="fas fa-save"></i>&nbsp; Save
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
    </button>
  </div>
</div>
